import { getMyClients } from '../../../api/persons'
import { SimpleCustomerDto } from '../../../api/persons/dto/simple-customer.dto'
import {
  ROLE_PLATFORM_HIXME_ADMIN,
  ROLE_CLIENT_ADMIN,
} from '@hixme/role-policy'

// Return the clients HR Admins can administer for which census-v2 is enabled
export async function clientsAllowedByCensusV2Flag({
  userRole,
  flags,
}: {
  userRole: string
  flags: Record<string, any>
}) {
  const myClients: SimpleCustomerDto[] = await getMyClients()

  // For both platform admin and HR admin, return the full list from getMyClients
  // (which is already filtered based on user role)
  if (
    userRole === ROLE_PLATFORM_HIXME_ADMIN ||
    userRole === ROLE_CLIENT_ADMIN
  ) {
    return myClients
  }

  // For other roles, use the feature flag logic
  const canUseCensusV2ClientIds: string[] =
    flags['ui.admin.enable-census-v2-for-client'] ?? []
  return myClients.filter((client) =>
    canUseCensusV2ClientIds.includes(client.id)
  )
}
